import { Layout } from "./types/layout";

export const createLayout = (): Layout => {
  return {
    zIndex: {
      0: 0,
      10: 10,
      20: 20,
      30: 30,
      40: 40,
      50: 50,
      auto: "auto",
    },
  };
};
